<template>
  <AsPopup
    title="Video trực tiếp"
    wrapClass="as-popup__schedule-wrap"
    :popupClass="`as-popup__schedule as-popup__schedule-${siteName}`"
    :isShowPopup="isShowPopup"
    :isShowHeader="false"
    @toggle="toggle"
  >
    <template #content>
      <div v-if="match" class="as-popup__schedule-content">
        <div class="as-popup__schedule-header">
          <div class="as-popup__schedule-title">
            Video trực tiếp
          </div>
          <button type="button" class="as-popup__schedule-close-btn" aria-label="Close"
            @click="$emit('toggle', false)"></button>
        </div>
        <div class="as-popup__schedule-body">
          <div class="as-popup__schedule-team-info">
            <div class="as-time as-flex as-text-center">
              {{ formatLocalTime(match.match_time, "h:mm DD/MM") }}
            </div>
            <div class="as-info as-flex as-text-center">
              <div class="as-team-home">
                <img :src="getImgUrlBySport('team', match.home_team?.id)" :alt="getTeamNameShow(match.home_team)"
                  class="as-lazyload as-popup__schedule-team-logo" />
                <span class="as-team-name">{{
                  getTeamNameShow(match.home_team)
                }}</span>
              </div>
              <div class="as-score">
                <div class="as-popup__schedule-score">
                  <span :class="`as-score-vs as-score-vs__only-text as-score-vs__only-text-${siteName}`">
                    VS
                  </span>
                </div>
              </div>
              <div class="as-team-away">
                <img :src="getImgUrlBySport('team', match.away_team?.id)" :alt="getTeamNameShow(match.away_team)"
                  class="as-lazyload as-popup__schedule-team-logo" />
                <span class="as-team-name">{{
                  getTeamNameShow(match.away_team)
                }}</span>
              </div>
            </div>
          </div>

          <div class="as-popup__schedule-link">
            <ul v-if="sites" class="as-stream-links-grid">
              <li v-for="site in sites" class="as-stream-link-item">
                <a :href="`https://${site.domain}/${site.slug}/${match.match_live_item?.name}`" target="_blank">
                  <span :class="`as-stream-link-item__logo as-stream-link-item__logo-${site.name}`"></span>
                  <span class="as-stream-link-item__name">{{ site?.title ?? site.name }}</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="as-popup__schedule-note">
            <span class="as-stream-note-text">
              Các video trực tiếp được cư dân mạng chia sẻ.
            </span>
          </div>
        </div>
      </div>
    </template>
  </AsPopup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { IMatch, ISites } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamNameShow } from "~src/helpers";
import { usecommonStore } from "~src/stores/CommonStore";
import AsPopup from "~src/components/AsPopup.vue";

const commonStore = usecommonStore();

const emits = defineEmits(["toggle"]);

interface IProps {
  isShowPopup: Boolean;
  match: IMatch;
  sites: ISites[];
}

const props = withDefaults(defineProps<IProps>(), {});
const siteName = computed(() => commonStore.getSiteName);

const toggle = () => {
  emits("toggle");
};
</script>
